<template>
  <div class="pad30-lr min-height seller-style">
    <div class="f20 fb gray3 pad20-tb border-b mar20-b">售后订单</div>
    <el-tabs class="f16" v-model="tabsactive" @tab-click="tabClick">
      <el-tab-pane name="all">
        <span slot="label" class="f16 fb">
          全部
          <!-- <template v-if="statusCount[0]">({{ statusCount[0] }})</template> -->
        </span>
      </el-tab-pane>
      <el-tab-pane name="0">
        <span slot="label" class="f16 fb">
          申请中<template v-if="statusCount[1]">({{ statusCount[1] }})</template>
        </span>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label" class="f16 fb">
          已驳回<template v-if="statusCount[3]">({{ statusCount[3] }})</template>
        </span>
      </el-tab-pane>
      <el-tab-pane name="1">
        <span slot="label" class="f16 fb">
          已通过<template v-if="statusCount[2]">({{ statusCount[2] }})</template>
        </span>
      </el-tab-pane>
    </el-tabs>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="订单编号">
        <el-input v-model="formInline.orderId" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="售后单号">
        <el-input v-model="formInline.refundOrderId" placeholder="请输入售后单号"></el-input>
      </el-form-item>
      <el-form-item label="店铺名称">
        <el-input v-model="formInline.shopName" placeholder="请输入店铺名称"></el-input>
      </el-form-item>
      <el-form-item label="货品名称">
        <el-input v-model="formInline.goodsName" placeholder="请输入货品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column prop="refundOrderId" label="售后单号" min-width="200"> </el-table-column>
      <el-table-column prop="orderId" label="订单编号" min-width="200"> </el-table-column>
      <el-table-column prop="orderAmount" label="订单金额" min-width="100"> </el-table-column>
      <el-table-column prop="refundAmount" label="退款金额" min-width="100"> </el-table-column>
      <el-table-column prop="applyTime" label="申请时间" min-width="200"> </el-table-column>
      <el-table-column prop="refundReasonCn" label="退款原因" min-width="200"> </el-table-column>
      <el-table-column prop="refundStatusCn" label="售后状态" min-width="200"> </el-table-column>
      <el-table-column prop="finishTime" label="退款/驳回时间" min-width="200"> </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-right mar20-tb">
      <el-pagination background layout="prev, pager, next" :total="total" @current-change="currentChange"> </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      loading: false,
      tableData: [],
      formInline: {
        orderId: "",
        refundOrderId: "",
        shopName: "",
        goodsName: "",
      },
      tabsactive: "all",
      pageSize: 10,
      pageNum: 1,
      searchVal: "",
      statusCount: [],
    };
  },
  created() {
    this.getData();
    this.getStatusMarkersCount();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        terminalType: 1,
        searchText: this.searchVal,
        shopName: this.formInline.shopName,
        goodsName: this.formInline.goodsName,
        orderId: this.formInline.orderId,
        refundOrderId: this.formInline.refundOrderId,
        refundStatus: this.tabsactive == "all" ? "" : this.tabsactive,
      };
      this.$store.dispatch("aftersales/selPage", params).then((res) => {
        if (res.code === "0") {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
        this.loading = false;
      });
    },
    currentChange(page) {
      this.pageNum = page;
      this.getData();
    },
    getStatusMarkersCount() {
      this.$store.dispatch("aftersales/getStatusMarkersCount", { isSeller: 0 }).then((res) => {
        if (res.code === "0" && res.data) {
          this.statusCount = [
            Number(res.data.applyingCount) + Number(res.data.passedCount) + Number(res.data.rejectedCount),
            res.data.applyingCount,
            res.data.passedCount,
            res.data.rejectedCount,
          ];
        }
      });
    },
    tabClick() {
      this.pageNum = 1;
      this.getData();
      this.getStatusMarkersCount();
    },
    handleClick(row) {
      window.open(`${process.env.VUE_APP_APP}v/aftersales/detail/${row.refundOrderId}?type=buyer&orderId=${row.orderId}`);
      console.log(row);
    },
    onSubmit() {
      this.pageSize = 10;
      this.getData();
      console.log("submit!");
    },
    rest() {
      Object.keys(this.formInline).forEach((key) => {
        this.formInline[key] = "";
      });
      this.pageSize = 10;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped></style>
